import React from 'react';
import { Route, BrowserRouter, Redirect, Switch } from 'react-router-dom';
import Login from './public/Login/Login';
import Dashboard from './private/Dashboard/Dashboard';
import Users from './private/Users/Users';
import Limits from './private/Limits/Limits';
import Settings from './private/Settings/Settings'
import Logs from './private/Logs/Logs';
import Symbols from './private/Symbols/Symbols';
import TelegramChat from './private/Users/TelegramChat';
import BlogPosts from './private/Blog/BlogPosts';
import BlogPost from './private/Blog/BlogPost';
import NotFound from './components/NotFound';

function Routes() {

    function PrivateRoute({ children, ...rest }) {
        return (
            <Route {...rest} render={() => {
                return localStorage.getItem("token")
                    ? children
                    : <Redirect to='/' />
            }} />
        )
    }

    return (
        <BrowserRouter>
            <Switch>
                <Route path="/" exact>
                    <Login />
                </Route>
                <PrivateRoute path="/dashboard">
                    <Dashboard />
                </PrivateRoute>
                <PrivateRoute path="/settings">
                    <Settings />
                </PrivateRoute>
                <PrivateRoute path="/symbols">
                    <Symbols />
                </PrivateRoute>
                <PrivateRoute path="/logs">
                    <Logs />
                </PrivateRoute>
                <PrivateRoute path="/users">
                    <Users />
                </PrivateRoute>
                <PrivateRoute path="/limits">
                    <Limits />
                </PrivateRoute>
                <PrivateRoute path="/telegram-chat">
                    <TelegramChat />
                </PrivateRoute>
                <PrivateRoute path="/blog/:id">
                    <BlogPost />
                </PrivateRoute>
                <PrivateRoute path="/blog" exact>
                    <BlogPosts />
                </PrivateRoute>
                <Route>
                    <NotFound />
                </Route>
            </Switch>
        </BrowserRouter>
    )
}

export default Routes;
